// Mock data para desenvolvimento

export const mockAnuncios = [
  {
    id: '1',
    titulo: 'Garanhão Mangalarga Marchador',
    descricao: 'Lindo garanhão de 5 anos, domado, excelente genealogia. Marcha batida perfeita.',
    preco: 45000,
    raca: 'Mangalarga Marchador',
    idade: 5,
    sexo: 'MACHO',
    cidade: 'Belo Horizonte',
    estado: 'MG',
    status: 'ATIVO',
    visualizacoes: 234,
    createdAt: '2026-01-15T10:00:00Z',
    fotos: [{ url: 'https://images.unsplash.com/photo-1553284965-83fd3e82fa5a?w=800' }],
    usuario: { id: '1', nome: 'João Silva', cidade: 'BH', estado: 'MG' }
  },
  {
    id: '2',
    titulo: 'Égua Quarto de Milha - Prenha',
    descricao: 'Égua mansa, ótima para laço. Prenha de 6 meses de garanhão campeão.',
    preco: 28000,
    raca: 'Quarto de Milha',
    idade: 7,
    sexo: 'FEMEA',
    cidade: 'Ribeirão Preto',
    estado: 'SP',
    status: 'ATIVO',
    visualizacoes: 156,
    createdAt: '2026-01-20T14:30:00Z',
    fotos: [{ url: 'https://images.unsplash.com/photo-1598974357801-cbca100e65d3?w=800' }],
    usuario: { id: '2', nome: 'Maria Souza', cidade: 'Ribeirão Preto', estado: 'SP' }
  },
  {
    id: '3',
    titulo: 'Potro Crioulo - 2 anos',
    descricao: 'Potro com excelente morfologia, filho de campeão morfológico.',
    preco: 18500,
    raca: 'Crioulo',
    idade: 2,
    sexo: 'MACHO',
    cidade: 'Pelotas',
    estado: 'RS',
    status: 'ATIVO',
    visualizacoes: 89,
    createdAt: '2026-02-01T09:00:00Z',
    fotos: [{ url: 'https://images.unsplash.com/photo-1534773728080-33d31da27ae5?w=800' }],
    usuario: { id: '3', nome: 'Pedro Gomes', cidade: 'Pelotas', estado: 'RS' }
  },
  {
    id: '4',
    titulo: 'Égua Paint Horse - Adestrada',
    descricao: 'Égua dócil, ideal para crianças. Participa de provas de tambor.',
    preco: 32000,
    raca: 'Paint Horse',
    idade: 6,
    sexo: 'FEMEA',
    cidade: 'Goiânia',
    estado: 'GO',
    status: 'ATIVO',
    visualizacoes: 178,
    createdAt: '2026-01-28T16:00:00Z',
    fotos: [{ url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800' }],
    usuario: { id: '4', nome: 'Ana Costa', cidade: 'Goiânia', estado: 'GO' }
  },
  {
    id: '5',
    titulo: 'Garanhão Lusitano Puro',
    descricao: 'Importado de Portugal, documentação completa. Ideal para adestramento clássico.',
    preco: 120000,
    raca: 'Lusitano',
    idade: 8,
    sexo: 'MACHO',
    cidade: 'São Paulo',
    estado: 'SP',
    status: 'ATIVO',
    visualizacoes: 445,
    createdAt: '2026-01-10T11:00:00Z',
    fotos: [{ url: 'https://images.unsplash.com/photo-1509914398892-963f53e6e2f1?w=800' }],
    usuario: { id: '5', nome: 'Carlos Mendes', cidade: 'São Paulo', estado: 'SP' }
  },
  {
    id: '6',
    titulo: 'Mula de Marcha - Muito Mansa',
    descricao: 'Mula de 4 anos, marcha picada suave. Perfeita para cavalgadas longas.',
    preco: 8500,
    raca: 'Muar',
    idade: 4,
    sexo: 'FEMEA',
    cidade: 'Montes Claros',
    estado: 'MG',
    status: 'ATIVO',
    visualizacoes: 67,
    createdAt: '2026-02-03T08:00:00Z',
    fotos: [{ url: 'https://images.unsplash.com/photo-1550581190-9c1c48d21d6c?w=800' }],
    usuario: { id: '6', nome: 'José Oliveira', cidade: 'Montes Claros', estado: 'MG' }
  }
];

export const mockPlanos = [
  {
    id: '1',
    nome: 'Básico',
    preco: 0,
    anunciosAtivos: 2,
    fotos: 3,
    destaque: false,
    descricao: 'Ideal para começar'
  },
  {
    id: '2',
    nome: 'Profissional',
    preco: 49.90,
    anunciosAtivos: 10,
    fotos: 10,
    destaque: true,
    descricao: 'Para criadores'
  },
  {
    id: '3',
    nome: 'Premium',
    preco: 99.90,
    anunciosAtivos: 50,
    fotos: 20,
    destaque: true,
    descricao: 'Para haras'
  }
];

export const mockUsuario = {
  id: '1',
  nome: 'Usuário Teste',
  email: 'teste@boilx.com.br',
  telefone: '(11) 99999-9999',
  cidade: 'São Paulo',
  estado: 'SP',
  tipo: 'ANUNCIANTE',
  createdAt: '2026-01-01T00:00:00Z'
};

export const mockConversas = [
  {
    id: '1',
    anuncio: mockAnuncios[0],
    participantes: [mockUsuario, { id: '2', nome: 'Maria Souza' }],
    ultimaMensagem: 'Ainda está disponível?',
    ultimaMensagemEm: '2026-02-07T10:30:00Z',
    naoLidas: 2
  }
];
